var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view makeInvoice" },
    [
      _vm.pageMode === 0
        ? _c(
            "div",
            { staticClass: "main-content" },
            [
              _c(
                "search-item",
                {
                  key: "tabMakeInvoice_makeInvoiceMethod",
                  ref: "searchItem",
                  attrs: {
                    "show-more-scheme": true,
                    "show-simple": true,
                    "expand-adv": true,
                    "is-append-query": true,
                    "search-item-code":
                      _vm.normalSearchItemConfigs[
                        _vm.searchConditions.makeInvoiceMethod - 1
                      ].searchItemCode,
                    "config-module":
                      _vm.normalSearchItemConfigs[
                        _vm.searchConditions.makeInvoiceMethod - 1
                      ].configModule,
                    "grid-config-module":
                      _vm.normalSearchItemConfigs[
                        _vm.searchConditions.makeInvoiceMethod - 1
                      ].gridConfigModule,
                    "auto-init": _vm.searchItemAutoInit,
                    "custom-search-items": _vm.customSearchItems,
                    "custom-sim-query-placeholder":
                      _vm.normalSearchItemConfigs[
                        _vm.searchConditions.makeInvoiceMethod - 1
                      ].simQueryPlaceholder
                  },
                  on: {
                    advSearchItemCallBack: _vm.fetchData,
                    simSearchItemCallBack: _vm.fetchDataBykeyWord,
                    advToggle: _vm.scrollCallback,
                    perConfigChange: function(value) {
                      _vm.perConfigName = value
                    },
                    refreshGrid: function() {
                      _vm.gridRefreshId += 1
                    },
                    defaultSearchItemsChange: function(value) {
                      _vm.defaultSearchItems = value
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "operations" }, slot: "operations" },
                    [
                      _vm.pageMode === 1
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "font-size": "14px",
                                color: "orangered"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.makeInvoiceBtnText
                                        .hedgeMakeInvoiceLabel
                                    )
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm.pageMode === 1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "1" },
                              on: { click: _vm.toChangePageMode }
                            },
                            [_vm._v(_vm._s(_vm.$t("Invoice.invoice_return")))]
                          )
                        : _vm._e(),
                      _vm.pageMode === 1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "2" },
                              on: { click: _vm.toHedgeMakeInvoice }
                            },
                            [_vm._v(_vm._s(_vm.$t("Invoice.invoice_confirm")))]
                          )
                        : _vm._e(),
                      _vm.pageMode !== 1 && _vm.btnMakeInvoice
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "3" },
                              on: { click: _vm.toMakeInvoice }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.makeInvoiceBtnText.makeInvoiceBtn)
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.pageMode !== 1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "4" },
                              on: { click: _vm.toHedgeMakeInvoicePage }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.makeInvoiceBtnText.hedgeMakeInvoiceBtn
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.searchConditions.makeInvoiceMethod === 1
                        ? [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "17" },
                                on: { click: _vm.signChargeEvent }
                              },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Mark")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "18" },
                                on: { click: _vm.cancelSignChargeEvent }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_CancelMark"))
                                )
                              ]
                            )
                          ]
                        : _vm._e(),
                      _vm.searchConditions.makeInvoiceMethod === 2
                        ? [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "19" },
                                on: { click: _vm.signBusinessEvent }
                              },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Mark")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "20" },
                                on: { click: _vm.cancelSignBusinessEvent }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_CancelMark"))
                                )
                              ]
                            )
                          ]
                        : _vm._e(),
                      _vm.searchConditions.makeInvoiceMethod === 3
                        ? [
                            _vm.pageMode !== 1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", no: "5" },
                                    on: { click: _vm.unConfirmBilling }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Invoice.invoice_cancelBillConfirmation"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "6" },
                                on: { click: _vm.signEvent }
                              },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Mark")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "7" },
                                on: { click: _vm.cancelSignEvent }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_CancelMark"))
                                )
                              ]
                            )
                          ]
                        : _vm._e(),
                      _vm.pageMode !== 1 &&
                      _vm.searchConditions.paymentType === -1 &&
                      _vm.$checkPermission([
                        "button_ACInvoice_autoCheckInvoicing"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "8" },
                              on: { click: _vm.autoCheckInvoicing }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Invoice.AutoCheckInvoicing"))
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.pageMode !== 1 &&
                      _vm.searchConditions.paymentType === -1 &&
                      _vm.$checkPermission([
                        "button_ACInvoice_autoCheckInvoicing"
                      ])
                        ? _c("i", {
                            staticClass: "el-icon-question",
                            staticStyle: {
                              color: "#00A6F4",
                              display: "inline-block",
                              position: "fixed"
                            },
                            attrs: {
                              slot: "reference",
                              no: "9",
                              title: _vm.$t(
                                "Invoice.AutoCheckInvoicingToolTips"
                              )
                            },
                            slot: "reference"
                          })
                        : _vm._e(),
                      _vm.$checkPermission([
                        "button_tabMakeInvoice_invoicePool"
                      ]) &&
                      _vm.pageMode !== 1 &&
                      _vm.searchConditions.paymentType === 0
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                no: "showInvoicePoolDialog"
                              },
                              on: { click: _vm.showInvoicePoolDialog }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_InvoicePoolReceiving")
                                )
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  ),
                  _c("template", { slot: "searchAreaHeader" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "app-main-inner-row extension-conditions-form"
                      },
                      [
                        _c(
                          "el-form",
                          { attrs: { inline: true, "label-position": "left" } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "el-form-item-search",
                                attrs: {
                                  label: _vm.$t(
                                    "Invoice.invoice_revenueAndExpenditureMethod"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { no: "10" },
                                    on: { change: _vm.initCustomSearchItems },
                                    model: {
                                      value: _vm.searchConditions.paymentType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.searchConditions,
                                          "paymentType",
                                          $$v
                                        )
                                      },
                                      expression: "searchConditions.paymentType"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          label: -1,
                                          disabled: !_vm.searchConditions
                                            .allowInvoiceQueryAll
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Invoice.invoice_all"))
                                        )
                                      ]
                                    ),
                                    _vm.$checkPermission([
                                      "button_tabMakeInvoice_arCharge"
                                    ])
                                      ? _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Invoice.invoice_receivables"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.$checkPermission([
                                      "button_tabMakeInvoice_apCharge"
                                    ])
                                      ? _c(
                                          "el-radio",
                                          { attrs: { label: 0 } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Invoice.invoice_payables"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "el-form-item-search",
                                attrs: {
                                  label: _vm.$t("Invoice.invoice_feeType")
                                }
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { no: "11" },
                                    model: {
                                      value:
                                        _vm.searchConditions.chargeTypeGroup,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.searchConditions,
                                          "chargeTypeGroup",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "searchConditions.chargeTypeGroup"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          label: -1,
                                          disabled: !_vm.searchConditions
                                            .createOverseaCharge
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Invoice.invoice_all"))
                                        )
                                      ]
                                    ),
                                    _c("el-radio", { attrs: { label: 0 } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Invoice.invoice_domestic")
                                        )
                                      )
                                    ]),
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          label: 1,
                                          disabled: !_vm.searchConditions
                                            .createOverseaCharge
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Invoice.invoice_international"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "el-form-item-search",
                                attrs: {
                                  label: _vm.$t(
                                    "Invoice.invoice_invoicingMethod"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { no: "12" },
                                    on: { change: _vm.makeInvoiceMethodChange },
                                    model: {
                                      value:
                                        _vm.searchConditions.makeInvoiceMethod,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.searchConditions,
                                          "makeInvoiceMethod",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "searchConditions.makeInvoiceMethod"
                                    }
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Invoice.invoice_charges")
                                        )
                                      )
                                    ]),
                                    _c("el-radio", { attrs: { label: 2 } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Invoice.invoice_business")
                                        )
                                      )
                                    ]),
                                    _c("el-radio", { attrs: { label: 3 } }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("Invoice.invoice_bill"))
                                      )
                                    ]),
                                    _c("el-radio", { attrs: { label: 4 } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Invoice.invoice_accountStatement"
                                          )
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.useOrderCenterMode,
                                    expression: "useOrderCenterMode"
                                  }
                                ],
                                staticClass: "el-form-item-search",
                                attrs: { "label-width": "0" }
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { no: "13" },
                                    model: {
                                      value:
                                        _vm.searchConditions.internalCharge,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.searchConditions,
                                          "internalCharge",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "searchConditions.internalCharge"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_InternalCharges")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm.pageMode === 0
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-search",
                                    attrs: { label: "" }
                                  },
                                  [
                                    _c("el-checkbox", { attrs: { no: "14" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Invoice.invoice_defaultInformation"
                                          )
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "el-form-item-search",
                                attrs: { label: _vm.inputDateLabel }
                              },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 8 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { "label-width": "0" } },
                                          [
                                            _c("el-date-picker", {
                                              attrs: {
                                                no: "15",
                                                type: "date",
                                                clearable: false,
                                                "value-format": "yyyy-MM-dd",
                                                "picker-options":
                                                  _vm.pickerOptions,
                                                editable: false
                                              },
                                              model: {
                                                value:
                                                  _vm.searchConditions
                                                    .inputDateStart,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.searchConditions,
                                                    "inputDateStart",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchConditions.inputDateStart"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c("el-col", { attrs: { span: 2 } }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Invoice.invoice_dateTo")
                                          )
                                        )
                                      ])
                                    ]),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 8 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { "label-width": "0" } },
                                          [
                                            _c("el-date-picker", {
                                              attrs: {
                                                no: "16",
                                                type: "date",
                                                clearable: "",
                                                "value-format": "yyyy-MM-dd",
                                                "picker-options":
                                                  _vm.pickerOptions
                                              },
                                              model: {
                                                value:
                                                  _vm.searchConditions
                                                    .inputDateEnd,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.searchConditions,
                                                    "inputDateEnd",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchConditions.inputDateEnd"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { "label-width": "0" } },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                attrs: { no: "17" },
                                                model: {
                                                  value:
                                                    _vm.allowTwoYearOutside,
                                                  callback: function($$v) {
                                                    _vm.allowTwoYearOutside = $$v
                                                  },
                                                  expression:
                                                    "allowTwoYearOutside"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Invoice.invoice_queryLotsOfData"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                2
              ),
              _vm.pageMode === 0
                ? _c(
                    "div",
                    { staticClass: "section grid-wrapper" },
                    [
                      _vm.searchConditions.makeInvoiceMethod === 1
                        ? _c("cargo-ag-grid-wrapper", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.pageMode === 0,
                                expression: "pageMode===0"
                              }
                            ],
                            key: "190601",
                            attrs: {
                              "config-module": "190601",
                              "per-config-name": _vm.perConfigName,
                              "refresh-id": _vm.gridRefreshId,
                              "grid-params": _vm.chargeGrid.gridParams,
                              "grid-options": _vm.chargeGrid.gridOptions,
                              "column-defs": _vm.chargeGrid.columnDefs,
                              "row-data": _vm.chargeGrid.rowData,
                              "show-row-groups": _vm.dataListDragGroup,
                              "enable-quick-value-convert": true
                            },
                            on: {
                              "update:gridParams": function($event) {
                                return _vm.$set(
                                  _vm.chargeGrid,
                                  "gridParams",
                                  $event
                                )
                              },
                              "update:grid-params": function($event) {
                                return _vm.$set(
                                  _vm.chargeGrid,
                                  "gridParams",
                                  $event
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm.searchConditions.makeInvoiceMethod === 2
                        ? _c("cargo-ag-grid-wrapper", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.pageMode === 0,
                                expression: "pageMode===0"
                              }
                            ],
                            key: "190602",
                            attrs: {
                              "config-module": "190602",
                              "per-config-name": _vm.perConfigName,
                              "refresh-id": _vm.gridRefreshId,
                              "grid-params": _vm.billingJobGrid.gridParams,
                              "grid-options": _vm.billingJobGrid.gridOptions,
                              "column-defs": _vm.billingJobGrid.columnDefs,
                              "row-data": _vm.billingJobGrid.rowData,
                              "show-row-groups": _vm.dataListDragGroup,
                              "enable-quick-value-convert": true
                            },
                            on: {
                              "update:gridParams": function($event) {
                                return _vm.$set(
                                  _vm.billingJobGrid,
                                  "gridParams",
                                  $event
                                )
                              },
                              "update:grid-params": function($event) {
                                return _vm.$set(
                                  _vm.billingJobGrid,
                                  "gridParams",
                                  $event
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm.searchConditions.makeInvoiceMethod === 3
                        ? _c("cargo-ag-grid-wrapper", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.pageMode === 0,
                                expression: "pageMode===0"
                              }
                            ],
                            key: "190603",
                            attrs: {
                              "config-module": "190603",
                              "per-config-name": _vm.perConfigName,
                              "refresh-id": _vm.gridRefreshId,
                              "grid-params": _vm.billingGrid.gridParams,
                              "grid-options": _vm.billingGrid.gridOptions,
                              "column-defs": _vm.dynamicColumnDefs,
                              "row-data": _vm.billingGrid.rowData,
                              "show-row-groups": _vm.dataListDragGroup,
                              "enable-quick-value-convert": true
                            },
                            on: {
                              "update:gridParams": function($event) {
                                return _vm.$set(
                                  _vm.billingGrid,
                                  "gridParams",
                                  $event
                                )
                              },
                              "update:grid-params": function($event) {
                                return _vm.$set(
                                  _vm.billingGrid,
                                  "gridParams",
                                  $event
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm.searchConditions.makeInvoiceMethod === 4
                        ? _c("cargo-ag-grid-wrapper", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.pageMode === 0,
                                expression: "pageMode===0"
                              }
                            ],
                            key: "190604",
                            attrs: {
                              "config-module": "190604",
                              "per-config-name": _vm.perConfigName,
                              "refresh-id": _vm.gridRefreshId,
                              "grid-params": _vm.billingGroupGrid.gridParams,
                              "grid-options": _vm.billingGroupGrid.gridOptions,
                              "column-defs": _vm.dynamicColumnDefs,
                              "row-data": _vm.billingGroupGrid.rowData,
                              "show-row-groups": _vm.dataListDragGroup,
                              "enable-quick-value-convert": true
                            },
                            on: {
                              "update:gridParams": function($event) {
                                return _vm.$set(
                                  _vm.billingGroupGrid,
                                  "gridParams",
                                  $event
                                )
                              },
                              "update:grid-params": function($event) {
                                return _vm.$set(
                                  _vm.billingGroupGrid,
                                  "gridParams",
                                  $event
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.pageMode === 1
        ? _c(
            "div",
            { staticClass: "main-content" },
            [
              _c(
                "search-item",
                {
                  key: "tabMakeInvoice_makeInvoiceMethodHedge",
                  ref: "searchItemHedge",
                  attrs: {
                    "show-more-scheme": true,
                    "show-simple": true,
                    "is-append-query": true,
                    "expand-adv": true,
                    "search-item-code":
                      _vm.hedgeSearchItemConfigs[
                        _vm.searchConditionsHedge.makeInvoiceMethod - 1
                      ].searchItemCode,
                    "config-module":
                      _vm.hedgeSearchItemConfigs[
                        _vm.searchConditionsHedge.makeInvoiceMethod - 1
                      ].configModule,
                    "grid-config-module":
                      _vm.hedgeSearchItemConfigs[
                        _vm.searchConditionsHedge.makeInvoiceMethod - 1
                      ].gridConfigModule,
                    "auto-init": _vm.searchItemAutoInitHedge,
                    "custom-search-items": _vm.initCustomSearchItemsHedge,
                    "custom-sim-query-placeholder":
                      _vm.hedgeSearchItemConfigs[
                        _vm.searchConditionsHedge.makeInvoiceMethod - 1
                      ].simQueryPlaceholder
                  },
                  on: {
                    advSearchItemCallBack: _vm.fetchData,
                    simSearchItemCallBack: _vm.fetchDataBykeyWord,
                    advToggle: _vm.scrollCallback,
                    perConfigChange: function(value) {
                      _vm.perConfigName = value
                    },
                    refreshGrid: function() {
                      _vm.gridRefreshId += 1
                    },
                    defaultSearchItemsChange: function(value) {
                      _vm.defaultSearchItemsHedge = value
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "operations" }, slot: "operations" },
                    [
                      _vm.pageMode === 1
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "font-size": "14px",
                                color: "orangered"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "padding-right": "15px",
                                    "font-size": "14px"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.makeInvoiceBtnText
                                          .hedgeMakeInvoiceLabel
                                      )
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.pageMode === 1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "18" },
                              on: { click: _vm.toChangePageMode }
                            },
                            [_vm._v(_vm._s(_vm.$t("Invoice.invoice_return")))]
                          )
                        : _vm._e(),
                      _vm.pageMode === 1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "19" },
                              on: { click: _vm.toHedgeMakeInvoice }
                            },
                            [_vm._v(_vm._s(_vm.$t("Invoice.invoice_confirm")))]
                          )
                        : _vm._e(),
                      _vm.pageMode !== 1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "20" },
                              on: { click: _vm.toMakeInvoice }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.makeInvoiceBtnText.makeInvoiceBtn)
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.pageMode !== 1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "21" },
                              on: { click: _vm.toHedgeMakeInvoicePage }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.makeInvoiceBtnText.hedgeMakeInvoiceBtn
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.searchConditions.makeInvoiceMethod === 3
                        ? [
                            _vm.pageMode !== 1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", no: "22" },
                                    on: { click: _vm.unConfirmBilling }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Invoice.invoice_cancelBillConfirmation"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "23" },
                                on: { click: _vm.signEvent }
                              },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Mark")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "24" },
                                on: { click: _vm.cancelSignEvent }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_CancelMark"))
                                )
                              ]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c("template", { slot: "searchAreaHeader" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "app-main-inner-row extension-conditions-form"
                      },
                      [
                        _c(
                          "el-form",
                          { attrs: { inline: true, "label-position": "left" } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "el-form-item-search",
                                attrs: {
                                  label: _vm.$t(
                                    "Invoice.invoice_revenueAndExpenditureMethod"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { no: "25" },
                                    model: {
                                      value:
                                        _vm.searchConditionsHedge.paymentType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.searchConditionsHedge,
                                          "paymentType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "searchConditionsHedge.paymentType"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          label: -1,
                                          disabled: !_vm.searchConditionsHedge
                                            .allowInvoiceQueryAll
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Invoice.invoice_all"))
                                        )
                                      ]
                                    ),
                                    _vm.$checkPermission([
                                      "button_tabMakeInvoice_arCharge"
                                    ])
                                      ? _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              label: 1,
                                              disabled: !_vm.properties.isAr
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Invoice.invoice_receivables"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.$checkPermission([
                                      "button_tabMakeInvoice_apCharge"
                                    ])
                                      ? _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              label: 0,
                                              disabled: !_vm.properties.isAr
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Invoice.invoice_payables"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "el-form-item-search",
                                attrs: {
                                  label: _vm.$t("Invoice.invoice_feeType")
                                }
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { no: "26" },
                                    model: {
                                      value:
                                        _vm.searchConditionsHedge
                                          .chargeTypeGroup,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.searchConditionsHedge,
                                          "chargeTypeGroup",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "searchConditionsHedge.chargeTypeGroup"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          label: -1,
                                          disabled: !_vm.searchConditionsHedge
                                            .createOverseaCharge
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Invoice.invoice_all"))
                                        )
                                      ]
                                    ),
                                    _c("el-radio", { attrs: { label: 0 } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Invoice.invoice_domestic")
                                        )
                                      )
                                    ]),
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          label: 1,
                                          disabled: !_vm.searchConditionsHedge
                                            .createOverseaCharge
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Invoice.invoice_international"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "el-form-item-search",
                                attrs: {
                                  label: _vm.$t(
                                    "Invoice.invoice_invoicingMethod"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { no: "27" },
                                    on: { change: _vm.makeInvoiceMethodChange },
                                    model: {
                                      value:
                                        _vm.searchConditionsHedge
                                          .makeInvoiceMethod,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.searchConditionsHedge,
                                          "makeInvoiceMethod",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "searchConditionsHedge.makeInvoiceMethod"
                                    }
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Invoice.invoice_charges")
                                        )
                                      )
                                    ]),
                                    _c("el-radio", { attrs: { label: 2 } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Invoice.invoice_business")
                                        )
                                      )
                                    ]),
                                    _c("el-radio", { attrs: { label: 3 } }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("Invoice.invoice_bill"))
                                      )
                                    ]),
                                    _c("el-radio", { attrs: { label: 4 } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Invoice.invoice_accountStatement"
                                          )
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.useOrderCenterMode,
                                    expression: "useOrderCenterMode"
                                  }
                                ],
                                staticClass: "el-form-item-search"
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { no: "28" },
                                    model: {
                                      value:
                                        _vm.searchConditionsHedge
                                          .internalCharge,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.searchConditionsHedge,
                                          "internalCharge",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "searchConditionsHedge.internalCharge"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_InternalCharges")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm.pageMode === 0
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-search",
                                    attrs: { label: "" }
                                  },
                                  [
                                    _c("el-checkbox", { attrs: { no: "29" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Invoice.invoice_defaultInformation"
                                          )
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "el-form-item-search",
                                attrs: { label: _vm.inputDateLabel }
                              },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 8 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { "label-width": "0" } },
                                          [
                                            _c("el-date-picker", {
                                              attrs: {
                                                no: "30",
                                                type: "date",
                                                clearable: false,
                                                "value-format": "yyyy-MM-dd",
                                                "picker-options":
                                                  _vm.pickerOptions,
                                                editable: false
                                              },
                                              model: {
                                                value:
                                                  _vm.searchConditions
                                                    .inputDateStart,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.searchConditions,
                                                    "inputDateStart",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchConditions.inputDateStart"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c("el-col", { attrs: { span: 2 } }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Invoice.invoice_dateTo")
                                          )
                                        )
                                      ])
                                    ]),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 8 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { "label-width": "0" } },
                                          [
                                            _c("el-date-picker", {
                                              attrs: {
                                                no: "31",
                                                type: "date",
                                                clearable: "",
                                                "value-format": "yyyy-MM-dd",
                                                "picker-options":
                                                  _vm.pickerOptions
                                              },
                                              model: {
                                                value:
                                                  _vm.searchConditions
                                                    .inputDateEnd,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.searchConditions,
                                                    "inputDateEnd",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchConditions.inputDateEnd"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { "label-width": "0" } },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                attrs: { no: "32" },
                                                model: {
                                                  value:
                                                    _vm.allowTwoYearOutside,
                                                  callback: function($$v) {
                                                    _vm.allowTwoYearOutside = $$v
                                                  },
                                                  expression:
                                                    "allowTwoYearOutside"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Invoice.invoice_queryLotsOfData"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                2
              ),
              _vm.pageMode === 1
                ? _c(
                    "div",
                    { staticClass: "section grid-wrapper" },
                    [
                      _vm.searchConditionsHedge.makeInvoiceMethod === 1
                        ? _c("cargo-ag-grid", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.pageMode === 1,
                                expression: "pageMode===1"
                              }
                            ],
                            key: "1906012",
                            attrs: {
                              "config-module": "1906012",
                              "per-config-name": _vm.perConfigName,
                              "refresh-id": _vm.gridRefreshId,
                              "grid-params": _vm.chargeGridHedge.gridParams,
                              "grid-options": _vm.chargeGridHedge.gridOptions,
                              "column-defs": _vm.chargeGrid.columnDefs,
                              "row-data": _vm.chargeGridHedge.rowData,
                              "enable-quick-value-convert": true
                            },
                            on: {
                              "update:gridParams": function($event) {
                                return _vm.$set(
                                  _vm.chargeGridHedge,
                                  "gridParams",
                                  $event
                                )
                              },
                              "update:grid-params": function($event) {
                                return _vm.$set(
                                  _vm.chargeGridHedge,
                                  "gridParams",
                                  $event
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm.searchConditionsHedge.makeInvoiceMethod === 2
                        ? _c("cargo-ag-grid", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.pageMode === 1,
                                expression: "pageMode===1"
                              }
                            ],
                            key: "1906022",
                            attrs: {
                              "config-module": "1906022",
                              "per-config-name": _vm.perConfigName,
                              "refresh-id": _vm.gridRefreshId,
                              "grid-params": _vm.billingJobGridHedge.gridParams,
                              "grid-options":
                                _vm.billingJobGridHedge.gridOptions,
                              "column-defs": _vm.billingJobGrid.columnDefs,
                              "row-data": _vm.billingJobGridHedge.rowData,
                              "enable-quick-value-convert": true
                            },
                            on: {
                              "update:gridParams": function($event) {
                                return _vm.$set(
                                  _vm.billingJobGridHedge,
                                  "gridParams",
                                  $event
                                )
                              },
                              "update:grid-params": function($event) {
                                return _vm.$set(
                                  _vm.billingJobGridHedge,
                                  "gridParams",
                                  $event
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm.searchConditionsHedge.makeInvoiceMethod === 3
                        ? _c("cargo-ag-grid", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.pageMode === 1,
                                expression: "pageMode===1"
                              }
                            ],
                            key: "1906032",
                            attrs: {
                              "config-module": "1906032",
                              "per-config-name": _vm.perConfigName,
                              "refresh-id": _vm.gridRefreshId,
                              "grid-params": _vm.billingGridHedge.gridParams,
                              "grid-options": _vm.billingGridHedge.gridOptions,
                              "column-defs": _vm.dynamicColumnDefs,
                              "row-data": _vm.billingGridHedge.rowData,
                              "enable-quick-value-convert": true
                            },
                            on: {
                              "update:gridParams": function($event) {
                                return _vm.$set(
                                  _vm.billingGridHedge,
                                  "gridParams",
                                  $event
                                )
                              },
                              "update:grid-params": function($event) {
                                return _vm.$set(
                                  _vm.billingGridHedge,
                                  "gridParams",
                                  $event
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm.searchConditionsHedge.makeInvoiceMethod === 4
                        ? _c("cargo-ag-grid", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.pageMode === 1,
                                expression: "pageMode===1"
                              }
                            ],
                            key: "1906042",
                            attrs: {
                              "config-module": "1906042",
                              "per-config-name": _vm.perConfigName,
                              "refresh-id": _vm.gridRefreshId,
                              "grid-params":
                                _vm.billingGroupGridHedge.gridParams,
                              "grid-options":
                                _vm.billingGroupGridHedge.gridOptions,
                              "column-defs": _vm.dynamicColumnDefs,
                              "row-data": _vm.billingGroupGridHedge.rowData,
                              "enable-quick-value-convert": true
                            },
                            on: {
                              "update:gridParams": function($event) {
                                return _vm.$set(
                                  _vm.billingGroupGridHedge,
                                  "gridParams",
                                  $event
                                )
                              },
                              "update:grid-params": function($event) {
                                return _vm.$set(
                                  _vm.billingGroupGridHedge,
                                  "gridParams",
                                  $event
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "pagination-wrapper", attrs: { id: "footer-wrapper2" } },
        [
          _c(
            "div",
            {
              class: [_vm.shouldFixed ? "fixedBottom" : ""],
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "flex-wrap": "wrap"
              }
            },
            [
              _vm.reCalc && _vm.searchConditions.makeInvoiceMethod === 1
                ? _c("charge-count-group", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.pageMode === 0,
                        expression: "pageMode===0"
                      }
                    ],
                    key: "1906011",
                    attrs: {
                      "selected-count":
                        _vm.totalAmountToCurrencyChargeGrid.selectedCount,
                      "data-provider":
                        _vm.totalAmountToCurrencyChargeGrid.dataProvider,
                      "display-and-count-field-list":
                        _vm.totalAmountToCurrencyChargeGrid
                          .displayAndCountFieldList,
                      "basic-currency": _vm.localCurrency,
                      "always-show": true,
                      source: "invoiceList"
                    }
                  })
                : _vm._e(),
              _vm.reCalc && _vm.searchConditions.makeInvoiceMethod === 2
                ? _c("charge-count-group", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.pageMode === 0,
                        expression: "pageMode===0"
                      }
                    ],
                    key: "1906021",
                    attrs: {
                      "selected-count":
                        _vm.totalAmountToCurrencyBillingJobGrid.selectedCount,
                      "data-provider":
                        _vm.totalAmountToCurrencyBillingJobGrid.dataProvider,
                      "display-and-count-field-list":
                        _vm.totalAmountToCurrencyBillingJobGrid
                          .displayAndCountFieldList,
                      "basic-currency": _vm.localCurrency,
                      "always-show": true
                    }
                  })
                : _vm._e(),
              _vm.reCalc && _vm.searchConditions.makeInvoiceMethod === 3
                ? _c("charge-count-group", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.pageMode === 0,
                        expression: "pageMode===0"
                      }
                    ],
                    key: "1906031",
                    attrs: {
                      "selected-count":
                        _vm.totalAmountToCurrencyBillingGrid.selectedCount,
                      "data-provider":
                        _vm.totalAmountToCurrencyBillingGrid.dataProvider,
                      "display-and-count-field-list":
                        _vm.totalAmountToCurrencyBillingGrid
                          .displayAndCountFieldList,
                      "basic-currency": _vm.localCurrency,
                      "always-show": true
                    }
                  })
                : _vm._e(),
              _vm.reCalc && _vm.searchConditions.makeInvoiceMethod === 4
                ? _c("charge-count-group", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.pageMode === 0,
                        expression: "pageMode===0"
                      }
                    ],
                    key: "1906041",
                    attrs: {
                      "selected-count":
                        _vm.totalAmountToCurrencyBillingGroupGrid.selectedCount,
                      "data-provider":
                        _vm.totalAmountToCurrencyBillingGroupGrid.dataProvider,
                      "display-and-count-field-list":
                        _vm.totalAmountToCurrencyBillingGroupGrid
                          .displayAndCountFieldList,
                      "basic-currency": _vm.localCurrency,
                      "always-show": true
                    }
                  })
                : _vm._e(),
              _vm.reCalc && _vm.searchConditionsHedge.makeInvoiceMethod === 1
                ? _c("charge-count-group", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.pageMode === 1,
                        expression: "pageMode===1"
                      }
                    ],
                    key: "19060121",
                    attrs: {
                      "selected-count":
                        _vm.totalAmountToCurrencyChargeGridHedge.selectedCount,
                      "data-provider":
                        _vm.totalAmountToCurrencyChargeGridHedge.dataProvider,
                      "display-and-count-field-list":
                        _vm.totalAmountToCurrencyChargeGrid
                          .displayAndCountFieldList,
                      "basic-currency": _vm.localCurrency,
                      "always-show": true
                    }
                  })
                : _vm._e(),
              _vm.reCalc && _vm.searchConditionsHedge.makeInvoiceMethod === 2
                ? _c("charge-count-group", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.pageMode === 1,
                        expression: "pageMode===1"
                      }
                    ],
                    key: "19060221",
                    attrs: {
                      "selected-count":
                        _vm.totalAmountToCurrencyBillingJobGridHedge
                          .selectedCount,
                      "data-provider":
                        _vm.totalAmountToCurrencyBillingJobGridHedge
                          .dataProvider,
                      "display-and-count-field-list":
                        _vm.totalAmountToCurrencyBillingJobGrid
                          .displayAndCountFieldList,
                      "basic-currency": _vm.localCurrency,
                      "always-show": true
                    }
                  })
                : _vm._e(),
              _vm.reCalc && _vm.searchConditionsHedge.makeInvoiceMethod === 3
                ? _c("charge-count-group", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.pageMode === 1,
                        expression: "pageMode===1"
                      }
                    ],
                    key: "19060321",
                    attrs: {
                      "selected-count":
                        _vm.totalAmountToCurrencyBillingGridHedge.selectedCount,
                      "data-provider":
                        _vm.totalAmountToCurrencyBillingGridHedge.dataProvider,
                      "display-and-count-field-list":
                        _vm.totalAmountToCurrencyBillingGrid
                          .displayAndCountFieldList,
                      "basic-currency": _vm.localCurrency,
                      "always-show": true
                    }
                  })
                : _vm._e(),
              _vm.reCalc && _vm.searchConditionsHedge.makeInvoiceMethod === 4
                ? _c("charge-count-group", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.pageMode === 1,
                        expression: "pageMode===1"
                      }
                    ],
                    key: "19060421",
                    attrs: {
                      "selected-count":
                        _vm.totalAmountToCurrencyBillingGroupGridHedge
                          .selectedCount,
                      "data-provider":
                        _vm.totalAmountToCurrencyBillingGroupGridHedge
                          .dataProvider,
                      "display-and-count-field-list":
                        _vm.totalAmountToCurrencyBillingGroupGrid
                          .displayAndCountFieldList,
                      "basic-currency": _vm.localCurrency,
                      "always-show": true
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm.searchConditions.makeInvoiceMethod === 1
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pageMode === 0 && _vm.appendQuery,
                      expression: "pageMode===0 && appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: {
                      total: _vm.searchConditions.totalChargeGrid,
                      layout: "total"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.searchConditions.makeInvoiceMethod === 1
            ? _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pageMode === 0 && !_vm.appendQuery,
                    expression: "pageMode===0 && !appendQuery"
                  }
                ],
                attrs: {
                  "config-module": "190601",
                  total: _vm.searchConditions.totalChargeGrid,
                  page: _vm.searchConditions.pageNumChargeGrid,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(
                      _vm.searchConditions,
                      "pageNumChargeGrid",
                      $event
                    )
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.fetchDataByPage
                }
              })
            : _vm._e(),
          _vm.searchConditions.makeInvoiceMethod === 2
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pageMode === 0 && _vm.appendQuery,
                      expression: "pageMode===0 && appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: {
                      total: _vm.searchConditions.totalBillingJobGrid,
                      layout: "total"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.searchConditions.makeInvoiceMethod === 2
            ? _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pageMode === 0 && !_vm.appendQuery,
                    expression: "pageMode===0 && !appendQuery"
                  }
                ],
                attrs: {
                  "config-module": "190602",
                  total: _vm.searchConditions.totalBillingJobGrid,
                  page: _vm.searchConditions.pageNumBillingJobGrid,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(
                      _vm.searchConditions,
                      "pageNumBillingJobGrid",
                      $event
                    )
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.fetchDataByPage
                }
              })
            : _vm._e(),
          _vm.searchConditions.makeInvoiceMethod === 3
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pageMode === 0 && _vm.appendQuery,
                      expression: "pageMode===0 && appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: {
                      total: _vm.searchConditions.totalBillingGrid,
                      layout: "total"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.searchConditions.makeInvoiceMethod === 3
            ? _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pageMode === 0 && !_vm.appendQuery,
                    expression: "pageMode===0 && !appendQuery"
                  }
                ],
                attrs: {
                  "config-module": "190603",
                  total: _vm.searchConditions.totalBillingGrid,
                  page: _vm.searchConditions.pageNumBillingGrid,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(
                      _vm.searchConditions,
                      "pageNumBillingGrid",
                      $event
                    )
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.fetchDataByPage
                }
              })
            : _vm._e(),
          _vm.searchConditions.makeInvoiceMethod === 4
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pageMode === 0 && _vm.appendQuery,
                      expression: "pageMode===0 && appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: {
                      total: _vm.searchConditions.totalBillingGroupGrid,
                      layout: "total"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.searchConditions.makeInvoiceMethod === 4
            ? _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pageMode === 0 && !_vm.appendQuery,
                    expression: "pageMode===0 && !appendQuery"
                  }
                ],
                attrs: {
                  "config-module": "190604",
                  total: _vm.searchConditions.totalBillingGroupGrid,
                  page: _vm.searchConditions.pageNumBillingGroupGrid,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(
                      _vm.searchConditions,
                      "pageNumBillingGroupGrid",
                      $event
                    )
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.fetchDataByPage
                }
              })
            : _vm._e(),
          _vm.searchConditions.makeInvoiceMethod === 1
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pageMode === 1 && _vm.appendQuery,
                      expression: "pageMode===1 && appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: {
                      total: _vm.searchConditionsHedge.totalChargeGrid,
                      layout: "total"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.searchConditionsHedge.makeInvoiceMethod === 1
            ? _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pageMode === 1 && !_vm.appendQuery,
                    expression: "pageMode===1 && !appendQuery"
                  }
                ],
                attrs: {
                  "config-module": "1906012",
                  total: _vm.searchConditionsHedge.totalChargeGrid,
                  page: _vm.searchConditionsHedge.pageNumChargeGrid,
                  limit: _vm.searchConditionsHedge.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(
                      _vm.searchConditionsHedge,
                      "pageNumChargeGrid",
                      $event
                    )
                  },
                  "update:limit": function($event) {
                    return _vm.$set(
                      _vm.searchConditionsHedge,
                      "pageSize",
                      $event
                    )
                  },
                  pagination: _vm.fetchDataByPage
                }
              })
            : _vm._e(),
          _vm.searchConditions.makeInvoiceMethod === 2
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pageMode === 1 && _vm.appendQuery,
                      expression: "pageMode===1 && appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: {
                      total: _vm.searchConditionsHedge.totalBillingJobGrid,
                      layout: "total"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.searchConditionsHedge.makeInvoiceMethod === 2
            ? _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pageMode === 1 && !_vm.appendQuery,
                    expression: "pageMode===1 && !appendQuery"
                  }
                ],
                attrs: {
                  "config-module": "1906022",
                  total: _vm.searchConditionsHedge.totalBillingJobGrid,
                  page: _vm.searchConditionsHedge.pageNumBillingJobGrid,
                  limit: _vm.searchConditionsHedge.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(
                      _vm.searchConditionsHedge,
                      "pageNumBillingJobGrid",
                      $event
                    )
                  },
                  "update:limit": function($event) {
                    return _vm.$set(
                      _vm.searchConditionsHedge,
                      "pageSize",
                      $event
                    )
                  },
                  pagination: _vm.fetchDataByPage
                }
              })
            : _vm._e(),
          _vm.searchConditions.makeInvoiceMethod === 3
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pageMode === 1 && _vm.appendQuery,
                      expression: "pageMode===1 && appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: {
                      total: _vm.searchConditionsHedge.totalBillingGrid,
                      layout: "total"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.searchConditionsHedge.makeInvoiceMethod === 3
            ? _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pageMode === 1 && !_vm.appendQuery,
                    expression: "pageMode===1 && !appendQuery"
                  }
                ],
                attrs: {
                  "config-module": "1906032",
                  total: _vm.searchConditionsHedge.totalBillingGrid,
                  page: _vm.searchConditionsHedge.pageNumBillingGrid,
                  limit: _vm.searchConditionsHedge.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(
                      _vm.searchConditionsHedge,
                      "pageNumBillingGrid",
                      $event
                    )
                  },
                  "update:limit": function($event) {
                    return _vm.$set(
                      _vm.searchConditionsHedge,
                      "pageSize",
                      $event
                    )
                  },
                  pagination: _vm.fetchDataByPage
                }
              })
            : _vm._e(),
          _vm.searchConditions.makeInvoiceMethod === 4
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pageMode === 1 && _vm.appendQuery,
                      expression: "pageMode===1 && appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: {
                      total: _vm.searchConditionsHedge.totalBillingGroupGrid,
                      layout: "total"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.searchConditionsHedge.makeInvoiceMethod === 4
            ? _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pageMode === 1 && !_vm.appendQuery,
                    expression: "pageMode===1 && !appendQuery"
                  }
                ],
                attrs: {
                  "config-module": "1906042",
                  total: _vm.searchConditionsHedge.totalBillingGroupGrid,
                  page: _vm.searchConditionsHedge.pageNumBillingGroupGrid,
                  limit: _vm.searchConditionsHedge.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(
                      _vm.searchConditionsHedge,
                      "pageNumBillingGroupGrid",
                      $event
                    )
                  },
                  "update:limit": function($event) {
                    return _vm.$set(
                      _vm.searchConditionsHedge,
                      "pageSize",
                      $event
                    )
                  },
                  pagination: _vm.fetchDataByPage
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("make-invoice-step-one-dialog", {
        attrs: {
          visible: this.step === "step1",
          title: this.title,
          params: _vm.makeInvoiceDialog.params,
          properties: this.properties,
          location: _vm.location,
          "view-source": "tabMakeInvoice"
        },
        on: {
          "update:visible": function(visible) {
            return _vm.handleStepVisibleChange("step1", visible)
          },
          lastFinsh: _vm.lastFinsh,
          toStepHandler: _vm.toStepHandler,
          generatedHandler: _vm.generatedHandler
        }
      }),
      false
        ? _c("make-invoice-step-two-dialog", {
            ref: "makeInvoiceStepTwoDialog",
            attrs: {
              visible: false,
              title: this.title,
              params: _vm.makeInvoiceStepTwoDialog.params,
              properties: this.properties,
              location: _vm.location
            },
            on: {
              "update:visible": function(visible) {
                return _vm.handleStepVisibleChange("step2", visible)
              },
              lastFinsh: _vm.lastFinsh,
              toStepHandler: _vm.toStepHandler,
              generatedHandler: _vm.generatedHandler,
              toSaveCatchHandler: _vm.toSaveCatchHandler
            }
          })
        : _vm._e(),
      _c("invoice-detail-dialog", {
        ref: "makeInvoiceDialog",
        attrs: {
          visible: this.step === "step3",
          title: this.title,
          params: _vm.makeInvoiceDialog.params,
          properties: this.properties,
          location: _vm.location
        },
        on: {
          "update:visible": function(visible) {
            return _vm.handleStepVisibleChange("step3", visible)
          },
          lastFinsh: _vm.lastFinsh,
          toStepHandler: _vm.toStepHandler,
          pageChange: _vm.pageChange
        }
      }),
      _c("make-invoice-dialog", {
        ref: "invoice",
        attrs: { "view-source": "invoice", location: _vm.location },
        on: { reloadData: _vm.reloadData, toStepHandler: _vm.toStepHandler }
      }),
      _c("sign-billing-dialog", {
        attrs: {
          visible: _vm.signBillingDialog.visible,
          "billing-keys": _vm.signBillingDialog.billingKeys
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.signBillingDialog, "visible", $event)
          },
          signBillingCallBack: _vm.signBillingCallBack
        }
      }),
      _c("sign-dialog", {
        attrs: {
          visible: _vm.signChargeDialog.visible,
          type: _vm.searchConditions.makeInvoiceMethod,
          title: _vm.$t("Clearing.MarkCharge")
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.signChargeDialog, "visible", $event)
          },
          signBillingCallBack: _vm.signChargeCallBack
        }
      }),
      _c("sign-dialog", {
        attrs: {
          visible: _vm.signBusinessDialog.visible,
          type: _vm.searchConditions.makeInvoiceMethod,
          title: _vm.$t("Clearing.MarkJob")
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.signBusinessDialog, "visible", $event)
          },
          signBillingCallBack: _vm.signBusinessCallBack
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            title: _vm.$t("Invoice.AutoCheckInvoicingAmount"),
            visible: _vm.autoCheckInvoiceDialog.visible,
            "close-on-click-modal": false,
            "append-to-body": "",
            "show-close": false,
            width: "400px"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c("el-form-item", { attrs: { "label-width": "0" } }, [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c("div", [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("Invoice.DefaultInvoicingAmount"))
                              )
                            ]),
                            _c("i", {
                              staticClass: "el-icon-question",
                              staticStyle: {
                                color: "#00A6F4",
                                display: "inline-block",
                                position: "fixed"
                              },
                              attrs: {
                                slot: "reference",
                                title: _vm.$t(
                                  "Invoice.AutoCheckInvoicingDialogToolTips"
                                )
                              },
                              slot: "reference"
                            })
                          ]),
                          _c(
                            "div",
                            [
                              _c("el-input-number", {
                                staticStyle: {
                                  width: "100px",
                                  "margin-left": "20px"
                                },
                                attrs: {
                                  no: "33",
                                  controls: false,
                                  min: 0,
                                  precision: 2
                                },
                                model: {
                                  value: _vm.autoCheckInvoiceDialog.amount,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.autoCheckInvoiceDialog,
                                      "amount",
                                      $$v
                                    )
                                  },
                                  expression: "autoCheckInvoiceDialog.amount"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { "margin-left": "5px" } },
                                [_vm._v("CNY")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "34" },
                  on: { click: _vm.autoCheckInvoiceConfirm }
                },
                [_vm._v(_vm._s(_vm.$t("Invoice.invoice_confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "35" },
                  on: {
                    click: function($event) {
                      _vm.autoCheckInvoiceDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.invoicePoolDialog.visible
        ? _c("invoice-pool-dialog", {
            attrs: {
              visible: _vm.invoicePoolDialog.visible,
              "seller-tax-name-default-value":
                _vm.invoicePoolDialog.sellerTaxNameDefaultValue,
              "selected-entities": _vm.invoicePoolDialog.selectedEntities,
              "make-invoice-method": _vm.invoicePoolDialog.makeInvoiceMethod,
              source: _vm.invoicePoolDialog.source,
              operation: _vm.invoicePoolDialog.operation,
              callback: _vm.invoicePoolCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.invoicePoolDialog, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }